// extracted by mini-css-extract-plugin
export default {"container":"switch_container__jXGmw","switch":"switch_switch__fMqRz","slider":"switch_slider__M0XMn","round":"switch_round__gJ1o1","label":"switch_label__zumPP"};